import { useLocation, useNavigate } from 'react-router-dom';
import { useTranslation } from '../../../../services/translation/hooks/useTranslation';
import { NavbarIconButtonWithLabel } from '../NavbarIconButtonWithLabel';
import { OnboardingIcon } from '../icons/OnboardingIcon';

export const OnboardingNavButton = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();

  const active = location.pathname === '/onboarding';

  return (
    <NavbarIconButtonWithLabel
      active={active}
      label={t('Onboarding')}
      onClick={() => {
        if (!active) {
          navigate('/onboarding');
        }
      }}
    >
      <OnboardingIcon />
    </NavbarIconButtonWithLabel>
  );
};
